var map = {
	"./World-Map2.svg": 3139,
	"./bg.png": 4145,
	"./icoDart_bg.png": 9058,
	"./icoDart_vert.png": 1328,
	"./icoFlutter_bg.png": 8334,
	"./icoFlutter_vert.png": 2537,
	"./logo.png": 4427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;